import React, { useCallback, useContext, useState } from 'react';
import LoadingContext from '../../contexts/LoadingContext';
import { useAuth } from '../../contexts/AuthContext';

import logoMh from '../../assets/logo_microhouse.png';

import './styles.css';

function Login(){
  const [login,setLogin] = useState('');
  const [senha,setSenha] = useState('');
  const [submitted,setSubmitted] = useState(false);
  const [comErro,setComErro] = useState(false);
  const loadingContext = useContext(LoadingContext);
  const { changeLoadingState } = loadingContext;
  const { signIn } = useAuth();

  const onLoginChange = useCallback((value: string) => {
    setComErro(false);
    setLogin(value);
  },[]);
 
  const onSenhaChange = useCallback((value: string) => {
    setComErro(false);
    setSenha(value);
  },[]);

  const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
    if(login && senha){
      changeLoadingState(true);
      try{
        await signIn({login,senha});
        changeLoadingState(false);
        setSubmitted(false);
      }catch(e){
        console.log(e);
        changeLoadingState(false);
        setSubmitted(false);
        setComErro(true);
      }
    }
  },[login,senha,changeLoadingState,setComErro, signIn])

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <div className="login-body">
        <div className="login-card">
          <div className="login-logo">
            <img width="218px" height="31px" src={logoMh} alt="Microhouse" />
            <p style={{margin: 0}}>Gerenciar Bancos</p>
          </div>
          <div className="login-inputs">
            <div>
              <span>
                <input 
                  autoFocus={true} 
                  className="login-input-element" 
                  type="text" 
                  name="login" 
                  placeholder="Login"
                  value={login} 
                  onChange={(e) => onLoginChange(e.target.value)} 
                />
                {submitted && !login && <p className="login-error-msg">Informe seu login</p>}
              </span>
            </div>
            <div>
              <span>
                <input 
                  className="login-input-element" 
                  type="password" 
                  name="senha" 
                  placeholder="Senha"
                  value={senha} 
                  onChange={(e) => onSenhaChange(e.target.value)} 
                />
                {submitted && !senha && <p className="login-error-msg">Informe sua senha</p>}
              </span>                  
            </div>
          </div>
          <div>
            <button className="login-button" type="submit">Acessar</button>
          </div> 
          {comErro && <p className="login-error-msg">Erro ao fazer login</p>}           
        </div>
      </div>
    </form>
  )
};

export default Login;